import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import useForm from "../../sharedComponents/customHooks/useForm";
import HTMLEditor from "../../sharedComponents/HTMLEditor/HTMLEditor";

const useStyles = makeStyles((theme) => ({
  grid: {
    padding: theme.spacing(1),
    alignSelf: "center",
  },
  question: {
    color: theme.palette.primary.main,
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1),
    },
  },
}));

const AdditionalInformation = (props) => {
  const classes = useStyles();

  const [state, setState] = useState(props.data);

  useEffect(() => {
    setState(props.data);
  }, [props.data]);

  const { errors, handleInputChange, values } = useForm(
    state,
    props.onChange,
    props.validationSchema
  );

  return (
    <Grid container>
      <Grid size={{ xs: 12, md: 12 }} className={classes.grid}>
        <HTMLEditor
          id="description" name="description"
          data={values && values.description ? values.description : ''}
          onChange={handleInputChange}
          error={undefined}
          />
        {/* <TextField
          id="description"
          variant="outlined"
          //label={<Typography variant="body2"></Typography>}
          size="small"
          fullWidth
          multiline
          rows={4}
          name="description"
          value={values && values.description ? values.description : ''}
          onChange={handleInputChange}
          error={errors && errors.description && errors.description.error}
        /> */}
      </Grid>
    </Grid>
  );
};

export default AdditionalInformation;
